import { FormikHelpers, FormikValues } from 'formik';
import React, { useState } from 'react';
import { number, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { Botao as BotaoForm, Campo, Selecao } from 'Component/Form';
import Icone from 'Component/Icone';
import Modal from 'Component/Modal';
import Aula from 'Interface/Aulas';
import { Erro } from 'Interface/Requisicao';
import {
  useEditarAulaMutation,
  useRecuperarAulaQuery,
  useRecuperarCursoQuery,
  useRecuperarModuloQuery,
} from 'Service';
import { useRecuperarUnidadesDeAprendizagemQuery } from 'View/Service/Default/UnidadesDeAprendizagem';

interface Props {
  exibir: boolean;
  aulaId: number;
  aoFechar: (estado: boolean) => void;
}

const regras = object({
  titulo: string().nullable().required('Obrigatório'),
  url: string().nullable().url('Não é uma URL').optional(),
  iesde: number().nullable().optional(),
});

const Editar = ({ exibir, aoFechar, aulaId }: Props): React.ReactElement => {
  const toast = useToast();
  const [termo, setTermo] = useState<string>('');
  const [editarAula] = useEditarAulaMutation();

  const { data: { aula } = {} } = useRecuperarAulaQuery(aulaId);
  const { data: { modulo } = {} } = useRecuperarModuloQuery(
    aula?.modulo_id || 0,
    {
      skip: !aula?.id,
    }
  );
  const { data: { curso } = {} } = useRecuperarCursoQuery(
    modulo?.curso_id || 0,
    {
      skip: !modulo?.id,
    }
  );
  const { data: { unidades_de_aprendizagem } = {} } =
    useRecuperarUnidadesDeAprendizagemQuery({
      finder: 'listaJson',
      options: { busca: { termo } },
    });

  const editar = async (
    dados: Aula,
    form: FormikHelpers<FormikValues>
  ): Promise<void> => {
    try {
      await editarAula(dados).unwrap();

      toast({ conteudo: 'Editado com sucesso!', tema: 'success' });

      aoFechar(false);
    } catch (erro) {
      const { data: errors } = erro as Erro;

      form.setStatus(errors);

      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <Modal exibir={exibir} aoFechar={aoFechar}>
      <Form onSubmit={editar} inicial={aula} regras={regras}>
        <Campo name="titulo" rotulo="Título da aula" />
        <React.Fragment>
          {curso?.tecnologia == 'lti' && (
            <Campo
              name="url"
              rotulo="URL da aula"
              prefixar={<Icone nome="link" />}
            />
          )}
          {curso?.tecnologia == 'iesde' && (
            <Campo name="codigo" rotulo="Código da aula" />
          )}
          {curso?.tecnologia == 'proprietaria' && (
            <React.Fragment>
              <Selecao
                name="unidade_de_aprendizagem_id"
                rotulo="Unidade de aprendizagem"
                opcoes={unidades_de_aprendizagem}
                buscar={setTermo}
              />
              <a
                href={`/admin/unidades-de-aprendizagem/editar/${aula?.unidade_de_aprendizagem_id}`}
                target="_blank"
                rel="noreferrer"
                className="d-block mt-n3 text-decoration-none"
              >
                Clique aqui para visualizar a unidade de aprendizagem
              </a>
            </React.Fragment>
          )}
        </React.Fragment>

        <div className="mt-5">
          <BotaoForm>Salvar</BotaoForm>
          <Botao ms onClick={() => aoFechar(false)} tema="light">
            Cancelar
          </Botao>
        </div>
      </Form>
    </Modal>
  );
};

export default Editar;
